export class WorkOrderComplete {
  caseNbr: string;
  noHitRequests: string;
  pendingRequests: string;
  removePending: string;
  removeNoHit: string;
  currentDte: string;
  currentStatus: string;
  newStatus: string;
  pendingComments: string;
  submit: string;
  persist: string;
  closeDt: string;
  confirmationMsg = '<br>' + 'Select OK if you would like to continue with this action. ' +  '<br>' + '<br>';
  msgLine = '______________________________________________________________' + '<br>' + '<br>';
  breakLine = '<br>' + '<br>';
  pendingRqstMsg = `The following will be placed in Pending Status.` + '<br>' + '<br>';
  removePendingMsg = 'The following will no longer be marked as Pending. ' +  '<br>' + '<br>';
  noHitsMsg = 'The following will be marked Completed. ' + '<br>' + '<br>';
  removeNoHitsMsg = 'The following will no longer be marked as Completed. '  +  '<br>' + '<br>';
  alertMsg: string;
  alertMsgS: string;
  alertMsgR: string;
  work: string;
  detailWork: string;
  requestNbr: string;
  refName: string;
}



// WEBPACK FOOTER //
// ./src/models/workOrderComplete.ts